import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class OutilXYService {
  #requeteOutilXY = new Subject<[number, number]>();

  requeteOutilXY$ = this.#requeteOutilXY.asObservable();

  afficherOutilXY(coords: [number, number]): void {
    this.#requeteOutilXY.next(coords);
  }
}
